module.exports = __webpack_public_path__ + "img/Feature.348cd578.png";